export default function Footer() {
    return (
    <footer>
        &copy; {new Date().getFullYear()} Dan Boudet - Built with <a href="https://reactjs.org/" target="_blank" rel="noreferrer">React</a> and <a href="https://material-ui.com/" target="_blank" rel="noreferrer">Material-UI</a>
    </footer>
    )
}